import React from 'react';
import numeral from 'numeral'
import classnames from 'classnames'
import { useDispatch, useSelector } from 'react-redux';

import ProjectBoardNumber from 'pu-react/components/ProjectBoardNumber';
import ProjectRevision from 'pu-react/components/ProjectRevision';
import ProjectSumaryItem from './ProjectSumaryItem';
import ProjectErrors from './ProjectErrors'
import ProjectWarnings from './ProjectWarnings'
import ProjectUploadFile from './ProjectUploadFile';
import EmailProjectQuote from './EmailProjectQuote';
import { deleteQuote as deleteParts } from '../../pcb-parts/data/PartsSlice'
import {
  deleteQuote as deleteAssembly,
  changeParameter as changeAssemblyParameter,
} from '../../pcb-assembly/data/AssemblySlice'
import {
  deleteQuote as deleteFabrication,
  changeParameter as changeFabricationParameter,
} from '../../pcb-fabrication/data/FabricationSlice'
import {
  addToCart,
  cancelProjectErrors,
  cancelProjectWarnings,
  changeParameter,
  uploadZipFile,
  closeZipFileTool,
  openBomFile,
  sendEmailQuote,
} from '../data/ProjectSlice';

import { extractQuoteServiceData, extractQuoteBomServiceData } from '../data/totals'

export default () => {
  const dispatch = useDispatch()
  const authToken = document.getElementsByName('authenticity_token')[0].value;
  const variantId = document.getElementById('variant_id').value;

  const assemblyState = useSelector((state) => state.assembly)
  const fabricationState = useSelector((state) => state.fabrication)
  const partsState = useSelector((state) => state.parts)

  const {
    bundle_rfq_number,
    parameters,
    loadingZipFile,
    directory,
    errors,
    projectErrors,
    projectWarnings,
  } = useSelector((state) => state.project)

  const { parameters: assemblyParams } = useSelector((state) => state.assembly)
  const { parametersCustomer: fabricationParams } = useSelector((state) => state.fabrication)
  const { bomQuoteNumber } = useSelector((state) => state.parts)

  const assemblyProps = extractQuoteServiceData(assemblyState)
  const fabricationProps = extractQuoteServiceData(fabricationState)
  const partsProps = extractQuoteBomServiceData(partsState)
  const total = assemblyProps.total + fabricationProps.total + partsProps.total
  const unitPrice = assemblyProps.unitPrice + fabricationProps.unitPrice + partsProps.unitPrice

  const itemProps = {
    pcbassembly: { ...assemblyProps, onDelete: () => dispatch(deleteAssembly()) },
    pcbfabrication: { ...fabricationProps, onDelete: () => dispatch(deleteFabrication()) },
    pcbparts: { ...partsProps, onDelete: () => dispatch(deleteParts()) },
  }

  const onAddToCart = () => {
    dispatch(addToCart(parameters, assemblyState, fabricationState, partsState))
  }
  const onCloseErrors = () => {
    dispatch(cancelProjectErrors())
  }
  const onCloseWarnings = () => {
    dispatch(cancelProjectWarnings())
  }

  const onChangeParameter = (name, value) => {
    // TODO: search if dispatch 4 actions at same time get some memory issues
    dispatch(changeParameter({ name, value }))
    dispatch(changeAssemblyParameter({ name, value }))
    dispatch(changeFabricationParameter({ name, value }))
    // dispatch(changePartsParameter({ name, value }))
  }

  const onUploadZipFile = (file) => {
    const bundle_number = document.getElementsByName('bundle_number')[0].value;
    const variant_id = document.getElementById('variant_id').value
    const descompress = document.getElementById('descompress').value

    dispatch(uploadZipFile(file, parameters, descompress, bundle_number, variant_id, authToken))
  }

  const onCloseZipFileTool = () => {
    dispatch(closeZipFileTool())
  }

  const onOpenBomFile = (bom_file) => {
    const bundle_number = document.getElementsByName('bundle_number')[0].value;
    dispatch(openBomFile(bom_file, bundle_number))
  }

  const paramProps = {
    parameters,
    onChangeParameter,
  }

  const onSendEmailQuote = (data) => {
    const body = {
      ...data,
      variant_id: variantId,
      parameters,
      quote_items: [],
    }
    if (assemblyParams && assemblyParams.product_quote_number) {
      body.quote_items.push(assemblyParams.product_quote_number)
    }
    if (fabricationParams && fabricationParams.product_quote_number) {
      body.quote_items.push(fabricationParams.product_quote_number)
    }
    if (bomQuoteNumber && bomQuoteNumber !== '') {
      body.quote_items.push(bomQuoteNumber)
    }
    dispatch(sendEmailQuote(body, authToken))
  }

  const klassAddToCart = classnames('text-uppercase btn btn-disable btn-add-cart', { active: total > 0 })

  const emailQuoteActive = total > 0

  return (
    <div className="project-summary sticky-top">
      <ProjectErrors projectErrors={projectErrors} onCloseErrors={onCloseErrors} />
      <ProjectWarnings projectWarnings={projectWarnings} onCloseWarnings={onCloseWarnings} />
      <div className="container">
        <div className="row">
          <div className="col-md-12 col-lg-4-custom project-info-section">
            <div className="row">
              <div className="col-xs-6 col-sm-6 col-lg-7">
                <div className="rfq-quote-block">
                  QUOTE #: {bundle_rfq_number}
                </div>
              </div>
              <div className="col-xs-6 col-sm-6 col-lg-5 project-actions">
                <ProjectUploadFile
                  filename={parameters.filename}
                  loadingZipFile={loadingZipFile}
                  onUploadZipFile={onUploadZipFile}
                  onCloseZipFileTool={onCloseZipFileTool}
                  onOpenBomFile={onOpenBomFile}
                  directory={directory}
                  errors={errors} />
              </div>
              <div className="col-xs-6 col-sm-6 col-lg-7 project-label">
                <ProjectBoardNumber
                  {...paramProps}
                  label="Part Number / Project Name"
                  tooltip=""
                  placeholder=""
                  required={false}
                  error={errors.part_number} />
              </div>
              <div className="col-xs-6 col-sm-6 col-lg-5 project-label">
                <ProjectRevision
                  {...paramProps}
                  label="Revision"
                  placeholder=""
                  required={false}
                  error={errors.revision} />
              </div>
            </div>
          </div>

          {bundle_items.map((item, index) => (
            <ProjectSumaryItem
              key={item.code}
              name={item.name}
              code={item.code}
              {...itemProps[item.code]}
              index={index} />
          ))}

          <div className="col-xs-4 col-sm-4 col-md-3 col-lg-2-custom total-section">
            <div>
              <div className="project-total-title">TOTAL PROJECT:</div>
              <div className="project-total-price">
                $ {numeral(total).format('0.00')}
              </div>
              <div className="unit-price">
                ( <span className="unit-price">${numeral(unitPrice).format('0.00')}</span> per board )
              </div>
            </div>
          </div>

          <div className="col-sm-12 col-md-3 col-lg-2 cart-section pb-0">
            <div className="cart-actions d-grid">
              <button type="button" href="#" className="btn btn-outline-gray d-none">
                SAVE FOR LATER
              </button>
              <button
                type="button"
                className={klassAddToCart}
                id="btn_add_to_cart"
                onClick={() => onAddToCart()}>
                ADD TO CART &nbsp;<i className="fas fa-caret-right" />
              </button>
              <div className="project-actions project-actions-spacing">
                <EmailProjectQuote
                  emailQuoteActive={emailQuoteActive}
                  onSendEmailQuote={onSendEmailQuote} />
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};
